import React, { createContext, useEffect, useState } from 'react'
import Button1 from '../../../../components/form/Button1'
import { Modal3 } from '../../../../components/DIsplay/Modal/Modal3'
import TaxForm from '../../../../components/Settings/tax/TaxForm';
import getTaxes from '../../../../controllers/Tax/getTaxes';
import CustomTable from '../../../../components/Table/CustomTable';
import Icon from '../../../../components/HOC/Icon';
import deleteTax from '../../../../controllers/Tax/deleteTax';
import { enqueueSnackbar } from 'notistack';

export default function TaxSetting() {
    const [data,setData] = useState([]);
    const [loadings,setLoadings] = useState({load: false,delete: false})
    const [openTaxForm,setOpenTaxForm] = useState(false);
    const [openEdit,setOpenEdit] = useState(false);
    const [openDelete,setOpenDelete] = useState(false);
    
    useEffect(() => {
        load()
    },[])

    async function load() {
        setLoadings({...loadings,load: true})
        const res = await getTaxes();
        setLoadings({...loadings,load: false})
        if(res?.return) {
            setData(res?.data?.data);
        }
    }

    const columns = [
        {field: 'taxName',headerName: 'Name',flex: 1},
        {field: 'taxAmount',headerName: 'Amount',flex: 1},
        {field: 'taxMethod',headerName: 'Method',flex: 1},
        {field: 'action',headerName: '',flex: 1,
            renderCell: (params) => (
                <ActionCol params={params} />
            )
        },
    ]
    console.log(data)

    async function handleDelete() {
        setLoadings({...loadings,delete: true})
        const res = await deleteTax(openDelete);
        setLoadings({...loadings,delete: false})
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            setOpenDelete(false);
            load();
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }

    const actions = {
        edit: (data) => {
            setOpenEdit(data);
        },
        remove: (id) => {
            setOpenDelete(id);
        }
    }
    
    
  return (
    <div className='flex flex-col gap-4'>
      <div className='flex gap-4 items-center justify-between'>
        <h5>Tax</h5>
        <div>
            <Button1 onClick={() => setOpenTaxForm(true)}>Add Tax</Button1>
        </div>
      </div>

      <ActionContext.Provider value={actions}>
        <CustomTable rows={data} columns={columns} />
      </ActionContext.Provider>

      <Modal3 open={openDelete} setOpen={() => setOpenDelete(false)}
        title='Delete Tax'
      >
        <div className='card p-6 flex flex-col gap-4'>
            <div className='text-xl'>Are you sure you want to delete this tax?</div>
            <div className='flex gap-4 items-center'>
                <dib>
                    <Button1 variant='text'>Cancel</Button1>
                </dib>
                <Button1 loading={loadings?.delete} onClick={handleDelete} className='!bg-red-500 !text-white'>Delete</Button1>
            </div>
        </div>
      </Modal3>
      <Modal3 open={openEdit} setOpen={() => setOpenEdit(false)}
        title='Edit Tax'
      >
        <div className='flex flex-col gap-4'>
            <TaxForm data={openEdit} callback={load} close={() => setOpenEdit(false)} />
        </div>
      </Modal3>

      <Modal3 open={openTaxForm} setOpen={() => setOpenTaxForm(false)}
        title='Add Tax'
      >
        <div className='flex gap-3 flex-col'>
            <TaxForm callback={load} close={() => setOpenTaxForm(false)} />
        </div>
      </Modal3>
    </div>
  )
}


const ActionContext = createContext();


function ActionCol({ params }) {
  return (
    <ActionContext.Consumer>
      {(value) => {
        const {edit, remove} = value || {};
        return (
            <div className="flex gap-2 ">
                <label
                className="bg-primary/10 rounded-md cursor-pointer p-2 text-primary/30"
                onClick={() => edit && edit(params?.row)}
                >
                <Icon icon="tabler:edit" />
                </label>
                <span
                className="p-2 bg-red-100 text-red-500 rounded-md cursor-pointer"
                onClick={() => remove && remove(params?.row?._id)}
                >
                <Icon icon="material-symbols-light:delete" />
                </span>
            </div>
        );
      }}
    </ActionContext.Consumer>
  );
}
